module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paypal-button",
    attrs: {
      "id": _vm.id
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c1e3006","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaypalButton.vue
// module id = 1162
// module chunks = 0